export default __webpack_public_path__ + "css/supplierDetails.bundle.css";